/** บทบาทผู้ดูแลสูงสุดจาก seed (roles.key = 'super_admin') */
export function isSuperAdminRole(role: { key?: string } | undefined | null): boolean {
  const k = role?.key?.toLowerCase()
  return k === 'super_admin' || k === 'superadmin'
}

/** ควบคุมการแสดงรายการ sidebar ให้สอดคล้องกับ permission จริงในระบบ */
export function canShowAdminSidebarItem(
  itemId: string,
  checkPermission: (key: string) => boolean,
  role?: { key?: string } | null,
): boolean {
  if (itemId === 'admin_user' || itemId === 'admin_role') {
    if (!isSuperAdminRole(role)) return false
  }
  if (itemId === 'admin_picklist') {
    return checkPermission('admin_picklist')
  }
  if (itemId === 'admin_company') {
    return checkPermission('admin_company') || checkPermission('admin_bill')
  }
  if (itemId === 'admin_settings') {
    return checkPermission('admin_company') || checkPermission('admin_bill')
  }
  return checkPermission(itemId)
}

export function canEditCompanyProfile(checkPermission: (key: string) => boolean): boolean {
  return checkPermission('admin_company') || checkPermission('admin_bill')
}
